import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer>
      <div className="footer-grid">
        {/* Col 1 — Brand */}
        <div className="footer-brand">
          <Link to="/">
            <img
              src="/logo-full.png"
              alt="iGamesTech"
              className="footer-logo-img"
            />
          </Link>

          <p>
            Digital Innovation with Data-Driven and AI-Integrated Web and
            Mobile App Development Company, and we also partner with{" "}
            <a
              href="https://itwelvetech.com"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-partner-link"
            >
              iTwelve Tech
            </a>
          </p>

          <div className="footer-social-row">
            <a href="#" aria-label="Facebook">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
              </svg>
            </a>

            <a href="#" aria-label="Instagram">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>

            <a href="#" aria-label="X (formerly Twitter)">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="currentColor"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
              </svg>
            </a>

            <a href="#" aria-label="LinkedIn">
              <svg
                viewBox="0 0 24 24"
                width="18"
                height="18"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
          </div>
        </div>

        {/* Col 2 — About */}
        <div className="footer-col">
          <h4>About</h4>
          <Link to="/about-us">iGamesTech</Link>
          <Link to="/services">Our Services</Link>
          <Link to="/careers">Careers</Link>
          <Link to="/news">News</Link>
          <Link to="/contact-us">Contact</Link>
        </div>

        {/* Col 3 — Contact */}
        <div className="footer-col">
          <h4>Contact</h4>

          <div className="footer-contact-item">
            <svg
              className="footer-icon"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" />
            </svg>

            <p>
              Unit No. 1017, 10th Floor,
              <br />
              SS Omnia, Sector 88, Gurugram
            </p>
          </div>

          <div className="footer-contact-item">
            <svg
              className="footer-icon"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 012.13 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
            </svg>

            <a href="tel:+919211343912">+91 92113 43912</a>
          </div>

          <div className="footer-contact-item">
            <svg
              className="footer-icon"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <path d="M22 6L12 13 2 6" />
            </svg>

            <a href="mailto:info@igamestech.com">
              info@igamestech.com
            </a>
          </div>
        </div>
      </div>

      {/* Bottom bar: copyright */}
      <div className="footer-bottom">
        <p>
          <span>© 2026 iGamesTech. All rights reserved.</span>

          <span className="footer-bottom-sep">|</span>

          <Link to="/terms-and-conditions">
            Terms &amp; Conditions
          </Link>

          <span className="footer-bottom-sep">|</span>

          <Link to="/privacy-policy">Privacy Policy</Link>

          <span className="footer-bottom-sep">|</span>

          <Link to="/cookie-policy">Cookie Policy</Link>
        </p>
      </div>
    </footer>
  );
}
